import React, { useState, useEffect } from "react";
import { Box, useTheme } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { tokens } from "../../theme";
import Header from "../../components/Header";
import { useNavigate } from "react-router-dom";
import { useAlert } from "../../global/AlertContext";
import { useDeleteLoteMutation, useGetLotesQuery } from "../../services/loteService";
import { lotesColumns } from "./config";
import { dataGridStyles, localeText } from "../../utils/dataGridConfig";
import ErrorComponent from "../../components/ErrorComponent";
import SearchFilter from "../../components/SearchComponent";

const Lotes = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const navigate = useNavigate();
  const showAlert = useAlert();

  const [searchTerm, setSearchTerm] = useState("");
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 10,
  });

  // Fetch data with pagination
  const { data: lotes, error, isLoading, refetch } = useGetLotesQuery({
    offset: paginationModel.page * paginationModel.pageSize,
    limit: paginationModel.pageSize,
    name: searchTerm
  });
  const [deleteLote] = useDeleteLoteMutation();
  
  // Re-fetch data when paginationModel changes
  useEffect(() => {
    refetch();
  }, [paginationModel, refetch, searchTerm]);

  const handleDelete = async (id) => {
    try {
      await deleteLote(id).unwrap();
      refetch();
      showAlert("Lote eliminado", "success");
    } catch (error) {
      showAlert(error.message, "error");
    }
  };
  const handleSeeApplications = async (id) => {
    navigate(`/applications?lote_id=${id}`, '_blank', 'noopener,noreferrer');
  };

  const handleView = async (id) => {
    navigate(`${window.location.pathname}/view/${id}`);
  };

  const handleEdit = async (id) => {
    navigate(`${window.location.pathname}/edit/${id}`);
  };

  const columns = lotesColumns( handleSeeApplications, handleView, handleEdit, handleDelete, colors);

  if (error) {
    return <ErrorComponent />;
  }

  return (
    <Box m="20px">
      <Header title="Lotes" subtitle="Lista de lotes" showCreateButton={true}/>
      
      {/* Filter Section */}
      <Box
        display="grid"
        gap="30px"
        gridTemplateColumns="repeat(12, minmax(0, 1fr))"
      >
        {/* Search Filter */}
        <Box sx={{ gridColumn: "span 2" }}>
          <SearchFilter
            onSearchChange={(term) => setSearchTerm(term)} // Pass search term to state
            label="Nombre"
          />
        </Box>
      </Box>

      <Box sx={dataGridStyles(colors)} height="75vh">
        <DataGrid
          // Table Distribution
          columns={columns}
          rows={lotes?.records || []}
          rowCount={lotes?.count || 0}
          loading={isLoading}
          // Pagination
          pagination
          paginationModel={paginationModel}
          rowsPerPageOptions={[10, 20, 50]}
          pageSizeOptions={[10, 20, 50]}
          paginationMode="server"
          onPaginationModelChange={(newPaginationModel) => {
            setPaginationModel(newPaginationModel);
          }}
          // Custom Table
          loadingText="Cargando..."
          localeText={localeText}
          disableRowSelectionOnClick
          disableColumnMenu
          disableColumnSorting
        />
      </Box>
    </Box>
  );
};

export default Lotes;